import { PaperSize } from '../Models/SkitterbookLivePagesRequest';
import { RadioGroup } from "../Controls/RadioGroup";
import './css/SkitterBookPaperSize.css';

interface SkitterBookPaperSizeProps {
    value: PaperSize;
    onChange?: (value: PaperSize) => void;
}

export const SkitterBookPaperSize: React.FC<SkitterBookPaperSizeProps> = ({
    value,
    onChange
}) => {
    return (
        <div className="sbps-container sbps-PaperSize-container">
            <RadioGroup<PaperSize>
                name="PaperSizeGroup"
                value={value}
                onChange={(val: PaperSize) => {
                    onChange?.(val);
                }}
                options={[
                    { value: "A4", label: <div className="skpspage-image"><span>A4 (210mm x 297mm)</span></div> },
                    { value: "LTR", label: <div className="skpspage-image"><span>Letter (8.5"" x 11"")</span></div> }
                ]}
                colors={{
                    border: "var(--color-static-background)",
                    foreground: "var(--color-component-foreground)",
                    background: "var(--color-component-background)",
                    hover: "var(--color-component-foreground)"
                }}
                className="PaperSize-group"
            />
        </div>
    );
};

export default SkitterBookPaperSize;
